import e from "react";
import { componentName as t } from "../../../utils/bem/index.js";
import { SelectableListItem as l } from "./SelectableListItem.js";
var n = function n(e) {
  return e;
};
function r(r) {
  var i = r.items,
    a = r.template,
    c = void 0 === a ? n : a,
    o = r.children;
  if (!i || 0 === i.length) return null;
  var m = t("selectable-flat-list", r.className);
  return e.createElement("ul", {
    className: m,
    onScroll: r.onScroll
  }, o, i.map(function (t, n) {
    var i,
      a = (null === (i = r.isSelectedFn) || void 0 === i ? void 0 : i.call(r, t, n)) || (null == t ? void 0 : t.selected);
    return e.createElement(l, {
      onClick: function onClick(e) {
        return r.onClick(t, n, e);
      },
      item: t,
      className: t.className,
      selected: a,
      template: c,
      index: n,
      key: n
    });
  }));
}
export { r as FlatList };